import { MetaPixel } from "./components/MetaPixel";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/Hero";
import { GmailReviews } from "./components/GmailReviews";
import { Problemas } from "./components/Problemas";
import { Tomos } from "./components/Tomos";
import { Opiniones } from "./components/Opiniones";
import { ContentPreview } from "./components/ContentPreview";
import { Bonos } from "./components/Bonos";
import { Comparison } from "./components/Comparison";
import { FinalOffer } from "./components/FinalOffer";
import { ObjecionesSoporte } from "./components/ObjecionesSoporte";
export function App() {
  return <div className="relative min-h-screen w-full text-blue-950" data-id="element-0" data-mp="31ctdnmtavs6j">
      {/* Fondo blanco con efecto borroso */}
      <div className="blurred-bg" aria-hidden="true" data-id="element-1" data-mp="2wi5l9cv6edmo" />
      <div className="blurred-blob-mid" aria-hidden="true" data-id="element-2" data-mp="28t4mkhc5agul" />

      <MetaPixel data-id="element-3" data-mp="23vkv2fqfs7kp" />

      {/* Contenedor mobile-first centrado */}
      <main className="mx-auto w-full max-w-md pb-16" data-id="element-4" data-mp="23t8i6gzjcnei">
        <Hero data-id="element-5" data-mp="3ikqwhsrnks2k" />
        <GmailReviews data-id="element-6" data-mp="3ij65ue8glt9z" />
        <Problemas data-id="element-7" data-mp="3ihv22ef0kliv" />
        <Tomos data-id="element-8" data-mp="3mljaezbgzl56" />
        <Opiniones data-id="element-9" data-mp="3ml14faz09sk2" />
        <ContentPreview data-id="element-10" data-mp="3mkhm3t5g125i" />

        {/* Bonos justo antes del precio */}
        <Bonos data-id="element-11" data-mp="3rcj8i7wbs999" />
        <Comparison data-id="element-12" data-mp="3rbzomln47asl" />

        {/* Oferta final: resumen, urgencia, precio y compra */}
        <FinalOffer data-id="element-13" data-mp="6hr7hlrojf6" />

        {/* Objeciones y soporte debajo de la oferta */}
        <ObjecionesSoporte data-id="element-14" data-mp="2zl3bdjx5744s" />

        <footer className="px-5 pt-10 text-center text-xs text-gray-400" data-id="element-15" data-mp="2zlv7qwykd5w4">
          © {new Date().getFullYear()} Psicología Deportiva para Atletas · Todos
          los derechos reservados
        </footer>
      </main>

      <PurchasePopup data-id="element-16" data-mp="38l05i12awv78" />
    </div>;
}